import React from 'react'
import TextArea from 'antd/es/input/TextArea'
import { Form } from 'antd'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'
import Access from '../../../../../../components/access/Access'
import Text from 'antd/es/typography/Text'

const TestMainClassName = ({ initialValue }) => {
    return (
        <Form.Item label='Main class name' name='mainClassName'>
            <Access
                permissions={[AssignmentPermissions.CAN_EDIT]}
                fallback={<Text>{initialValue ?? 'No main class name'}</Text>}
            >
                <TextArea />
            </Access>
        </Form.Item>
    )
}

export default TestMainClassName
